import { Link } from 'react-router-dom';

import AnubisImg from '../../assets/anubis-white.png';

import { AnubisContainer, Background } from './styles';

export const Home = () => {
  return (
    <Background>
      <AnubisContainer>
        <img src={AnubisImg} alt="anubis" width="300" />
        <Link to="/game">?</Link>
      </AnubisContainer>
    </Background>
  );
};
